import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
export default function Home(){
  return (
    <Container sx={{py:4}}>
      <Typography variant="h3" gutterBottom>Retail Ads — Smart In-store Advertising</Typography>
      <Typography variant="subtitle1" gutterBottom>Turn any screen into a smart ad display. Offline-ready, fast, and easy to manage.</Typography>
      <Box sx={{mt:3}}>
        <Button variant="contained" size="large" component={RouterLink} to="/pricing">Get Started</Button>
      </Box>
    </Container>
  );
}
